export const SELECT_SINGLE_NODE_REQ = "SELECT_SINGLE_NODE_REQ"
export const SELECT_SINGLE_NODE_SUCC = "SELECT_SINGLE_NODE_SUCC"
export const SELECT_SINGLE_NODE_FAIL = "SELECT_SINGLE_NODE_FAIL"
export const REMOVE_ALL_NODE = "REMOVE_ALL_NODE"
export const SELECT_ALL_NODE = "SELECT_ALL_NODE"